module.exports = __webpack_public_path__ + "img/form-card-shadow.010d9907.svg";